<template>
  <div>
    <PageMain :tableData="tableData" :loading="loading">
      <template #header>
        <div class="section-header-wrapper">
          <div class="section-header">
            <span class="section-bar" />
            <span class="section-title">{{ $l('section_container_record') || '分柜记录' }}</span>
            <span class="section-count">{{ count }} {{ $l('label_container_count_unit') || '柜' }}</span>
          </div>

          <el-button type="primary" plain size="mini" @click="visible = true">
            {{ $l('btn_container_mgmt') || '分柜管理' }}
          </el-button>
        </div>
      </template>
    </PageMain>

    <ContainerScheduling
      :visible.sync="visible"
      :shipmentCode="shipmentCode"
      :shipmentNo="shipmentNo"
      @reload="reload"
    />
  </div>
</template>

<script>
import PageMain from './main.vue'
import ContainerScheduling from '../container-scheduling/index.vue'
export default {
  components: { PageMain, ContainerScheduling },
  props: {
    shipmentCode: { type: String, default: '' },
    shipmentNo: { type: String, default: '' },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      visible: false,
    }
  },
  computed: {
    count() {
      return this.tableData?.length || 0
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    reload() {
      this.getData()
    },
    async getData() {
      if (!this.shipmentCode) return

      this.loading = true
      const res = await this.$api
        .ecomShipmentContainerListApi({ shipmentCode: this.shipmentCode })
        .catch(() => null)
      this.loading = false
      if (!res) return

      this.tableData = res.body?.data || []
    },
  },
}
</script>

<style lang="scss" scoped>
.section-header-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;

  .section-header {
    display: flex;
    align-items: center;
    gap: 8px;

    .section-bar {
      width: 3px;
      height: 16px;
      border-radius: 2px;
      background: #409eff;
    }
    .section-title {
      font-size: 14px;
      font-weight: 600;
      color: #334155;
    }
    .section-count {
      font-size: 11px;
      font-weight: 400;
      color: #94a3b8;
      margin-left: 5px;
    }
  }
}
</style>
